/* BIG LEDUP Konfigurator — Section-Controller (Vanilla JS, keine Abhängigkeiten).
   Die Section rendert bereits vollständiges HTML; dieses Skript übernimmt nur
   Interaktion: Standtyp, Breite, Add-ons, Bild, Preis, Galerie, Terminwahl, Absenden.
   Mehrfach-Instanzen sind erlaubt (pro .lk[data-lk-root] eine Instanz). */
(function () {
  'use strict';

  var EUR = function (n) { return n.toLocaleString('de-DE') + ' \u20ac'; };
  var ROUND10 = function (n) { return Math.round(n / 10) * 10; };

  function Konfigurator(root) {
    this.root = root;
    var cfgEl = root.querySelector('[data-lk-config]');
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    this.state = {
      typ: 'kopf', breite: 3, licht: true, img: '',
      url: '', loading: false,
      adv: false, theke: 'none', br: false, kab: false, tv: false,
      termin: false, tag: null, slot: null,
      lb: null, sending: false
    };
    this.q = function (sel) { return root.querySelector(sel); };
    this.qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    this.bind();
    this.buildTage();
    this.render();
  }

  Konfigurator.prototype.set = function (patch) {
    Object.assign(this.state, patch);
    this.render();
  };

  /* ---------- Events ---------- */
  Konfigurator.prototype.bind = function () {
    var self = this;
    var on = function (sel, ev, fn) {
      self.qa(sel).forEach(function (el) { el.addEventListener(ev, fn); });
    };

    on('[data-lk-typ]', 'change', function (e) { self.set({ typ: e.target.value }); });
    on('[data-lk-breite]', 'change', function (e) { self.set({ breite: parseInt(e.target.value, 10) }); });
    on('[data-lk-theke]', 'change', function (e) { self.set({ theke: e.target.value }); });
    on('[data-lk-addon="bruecke"]', 'change', function (e) { self.set({ br: e.target.checked }); });
    on('[data-lk-addon="kabine"]', 'change', function (e) { self.set({ kab: e.target.checked }); });
    on('[data-lk-addon="tv"]', 'change', function (e) { self.set({ tv: e.target.checked }); });
    on('[data-lk-light]', 'click', function () { self.set({ licht: !self.state.licht }); });
    on('[data-lk-adv-toggle]', 'click', function () { self.set({ adv: !self.state.adv }); });

    on('[data-lk-file]', 'change', function (e) {
      self.readFile(e.target.files && e.target.files[0]);
    });
    on('[data-lk-demo]', 'click', function (e) {
      self.set({ img: e.currentTarget.getAttribute('data-lk-demo') });
    });

    var stage = this.q('[data-lk-stage]');
    if (stage) {
      stage.addEventListener('dragover', function (e) { e.preventDefault(); stage.classList.add('is-drag'); });
      stage.addEventListener('dragleave', function () { stage.classList.remove('is-drag'); });
      stage.addEventListener('drop', function (e) {
        e.preventDefault();
        stage.classList.remove('is-drag');
        self.readFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
      });
    }

    var urlInput = this.q('[data-lk-url]');
    if (urlInput) {
      urlInput.addEventListener('input', function (e) { self.state.url = e.target.value; });
      urlInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self.generate(); }
      });
    }
    on('[data-lk-generate]', 'click', function () { self.generate(); });

    /* Galerie / Lightbox */
    on('[data-lk-open]', 'click', function (e) {
      self.set({ lb: parseInt(e.currentTarget.getAttribute('data-lk-open'), 10) });
    });
    on('[data-lk-close]', 'click', function (e) {
      if (e.target === e.currentTarget || e.currentTarget.hasAttribute('data-lk-close-btn')) self.set({ lb: null });
    });
    on('[data-lk-step]', 'click', function (e) {
      e.stopPropagation();
      self.step(parseInt(e.currentTarget.getAttribute('data-lk-step'), 10));
    });
    this._key = function (e) {
      if (self.state.lb === null) return;
      if (e.key === 'Escape') self.set({ lb: null });
      if (e.key === 'ArrowRight') self.step(1);
      if (e.key === 'ArrowLeft') self.step(-1);
    };
    document.addEventListener('keydown', this._key);

    /* Video */
    on('[data-lk-play]', 'click', function () { self.playVideo(); });

    /* Termin */
    on('[data-lk-termin]', 'change', function (e) { self.set({ termin: e.target.checked }); });

    var form = this.q('.lk-form-card form');
    if (form) form.addEventListener('submit', function (e) { self.submit(e); });
  };

  /* ---------- Bild ---------- */
  Konfigurator.prototype.readFile = function (f) {
    if (!f || !/^image\//.test(f.type)) return;
    var self = this, r = new FileReader();
    r.onload = function (e) { self.set({ img: e.target.result }); };
    r.readAsDataURL(f);
  };

  /* ---------- Design aus Website erzeugen (Node-Backend) ---------- */
  Konfigurator.prototype.generate = function () {
    var self = this;
    var url = (this.state.url || '').trim();
    if (!url) { this.note('Bitte zuerst eine Website-Adresse eingeben.'); return; }
    var api = this.cfg.designApi;
    this.set({ loading: true });
    this.note('Website wird ausgelesen und Design generiert \u2026');

    if (!api) {
      // Kein Backend konfiguriert: Demo-Design, damit die Seite trotzdem funktioniert.
      var demos = this.cfg.demos || [];
      if (!demos.length) { this.set({ loading: false }); this.note('Bitte Design-Endpoint in den Section-Einstellungen hinterlegen.'); return; }
      var pick = demos[Math.abs(url.length * 7 + url.charCodeAt(0)) % demos.length];
      setTimeout(function () {
        self.set({ loading: false, img: pick });
        self.note('Demo-Design f\u00fcr ' + url + ' \u2014 Ihr echtes CI-Design erzeugen wir im n\u00e4chsten Schritt.');
      }, 1200);
      return;
    }

    fetch(api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url: url, typ: this.state.typ, breite: this.state.breite, shop: this.cfg.shop })
    })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (data) {
        if (!data || !data.image) throw new Error('no image');
        self.set({ loading: false, img: data.image });
        self.note('Design aus ' + url + ' erzeugt. Gef\u00e4llt es? Fordern Sie das finale Rendering an.');
      })
      .catch(function () {
        self.set({ loading: false });
        self.note('Generierung fehlgeschlagen \u2014 bitte Datei hochladen oder Rendering anfordern.');
      });
  };

  Konfigurator.prototype.note = function (txt) {
    var el = this.q('[data-lk-ainote]');
    if (el) el.textContent = txt;
  };

  /* ---------- Lightbox ---------- */
  Konfigurator.prototype.step = function (d) {
    var g = this.cfg.gallery || [];
    if (this.state.lb === null || !g.length) return;
    this.set({ lb: (this.state.lb + d + g.length) % g.length });
  };

  /* ---------- Video ---------- */
  Konfigurator.prototype.playVideo = function () {
    var holder = this.q('[data-lk-video]');
    if (!holder) return;
    var src = this.cfg.videoUrl;
    if (!src) { this.q('[data-lk-video-missing]').hidden = false; return; }
    var v = document.createElement('video');
    v.src = src;
    v.controls = true;
    v.autoplay = true;
    v.playsInline = true;
    if (this.cfg.videoPoster) v.poster = this.cfg.videoPoster;
    holder.innerHTML = '';
    holder.appendChild(v);
  };

  /* ---------- Termin-Slots ---------- */
  Konfigurator.prototype.buildTage = function () {
    var wrap = this.q('[data-lk-tage]');
    if (!wrap) return;
    var self = this, out = [], d = new Date();
    d.setHours(0, 0, 0, 0);
    while (out.length < 5) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() === 0 || d.getDay() === 6) continue;
      out.push({
        id: d.toISOString().slice(0, 10),
        label: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'][d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1) + '.'
      });
    }
    this.tage = out;
    wrap.innerHTML = '';
    out.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lk-chip';
      b.textContent = t.label;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { self.set({ tag: t.id }); });
      b.dataset.id = t.id;
      wrap.appendChild(b);
    });

    var sw = this.q('[data-lk-slots]');
    if (!sw) return;
    sw.innerHTML = '';
    ['09:00', '10:30', '13:00', '14:30', '16:00', '17:30'].forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lk-chip';
      b.textContent = s;
      b.setAttribute('aria-pressed', 'false');
      b.dataset.id = s;
      b.addEventListener('click', function () { self.set({ slot: s }); });
      sw.appendChild(b);
    });
  };

  /* ---------- Ableitungen ---------- */
  Konfigurator.prototype.derive = function () {
    var s = this.state;
    var kabOff = s.typ === 'kopf' || s.breite < 3;
    var kab = s.kab && !kabOff;

    var addons = [];
    if (s.theke === 'one') addons.push('counter-one');
    if (s.theke === 'counter') addons.push('counter');
    if (s.br) addons.push('bruecke');
    if (kab) addons.push('kabine');
    if (s.tv) addons.push('tv');

    var extras = [];
    if (s.theke === 'one') extras.push('Counter One');
    if (s.theke === 'counter') extras.push('Counter');
    if (s.br) extras.push('Br\u00fccke');
    if (kab) extras.push('Kabine 1 \u00d7 1 m');
    if (s.tv) extras.push('TV-Halter');

    var layout = s.typ === 'eck' ? [3, s.breite]
      : s.typ === 'reihe' ? [1, s.breite, 1]
        : [s.breite];
    var totalM = layout.reduce(function (a, b) { return a + b; }, 0);
    var qm = +(totalM * 2.5).toFixed(1);
    var perSqm = this.cfg.pricePerSqm || 460;
    var price = ROUND10(qm * perSqm);

    var typName = s.typ === 'eck' ? 'Eckstand' : s.typ === 'reihe' ? 'Reihenstand' : 'Kopfstand';
    var masz = s.typ === 'eck'
      ? s.breite + ' \u00d7 3 m Eckstand \u00b7 2,5 m hoch'
      : s.typ === 'reihe'
        ? s.breite + ' m Reihenstand \u00b7 2 \u00d7 1 m Seitenw\u00e4nde \u00b7 2,5 m hoch'
        : s.breite + ' m Kopfstand \u00b7 2,5 m hoch';

    return {
      kabOff: kabOff, kab: kab, addons: addons, extras: extras,
      qm: qm, price: price, typName: typName, masz: masz
    };
  };

  /* ---------- Render ---------- */
  Konfigurator.prototype.render = function () {
    var s = this.state, d = this.derive(), self = this;
    var set = function (sel, txt) { var el = self.q(sel); if (el) el.textContent = txt; };
    var show = function (sel, on) { var el = self.q(sel); if (el) el.hidden = !on; };

    /* 3D */
    var viewer = this.q('ledup-3d');
    if (viewer) {
      viewer.setAttribute('typ', s.typ);
      viewer.setAttribute('breite', String(s.breite));
      viewer.setAttribute('licht', s.licht ? 'on' : 'off');
      viewer.setAttribute('image', s.img || '');
      viewer.setAttribute('addons', d.addons.join(','));
    }
    set('[data-lk-lightlabel]', s.licht ? 'Licht aus' : 'Licht an');
    show('[data-lk-noimage]', !s.img);

    /* Maße & Preis */
    set('[data-lk-masz]', d.masz);
    set('[data-lk-konfig]', d.masz);
    set('[data-lk-price]', 'ab ' + EUR(d.price));
    this.qa('[data-lk-price-plain]').forEach(function (el) { el.textContent = EUR(d.price); });
    set('[data-lk-sum]', 'ab ' + EUR(d.price + 690));
    set('[data-lk-qm]', String(d.qm).replace('.', ',') + ' m\u00b2 Wandfl\u00e4che');
    set('[data-lk-typlabel]', d.typName + ', ' + s.breite + ' m Front');
    var hidden = this.q('[data-lk-hidden-konfig]');
    if (hidden) hidden.value = d.masz + (d.extras.length ? ' | Zubeh\u00f6r: ' + d.extras.join(', ') : '');

    /* Add-ons */
    set('[data-lk-adv-sign]', s.adv ? '\u2013' : '+');
    set('[data-lk-adv-sum]', d.extras.length ? d.extras.join(' \u00b7 ') : 'Theke, Br\u00fccke, Kabine, TV-Halter');
    show('[data-lk-adv-body]', s.adv);
    show('[data-lk-extras]', d.extras.length > 0);
    set('[data-lk-extras-label]', d.extras.join(' \u00b7 '));

    var kabBox = this.q('[data-lk-addon="kabine"]');
    if (kabBox) {
      kabBox.disabled = d.kabOff;
      kabBox.checked = d.kab;
    }
    set('[data-lk-kabnote]', d.kabOff
      ? 'Braucht eine Ecke und Platz: ab Reihen- oder Eckstand mit 3 m Frontbreite.'
      : 'Zwei 1-m-Rahmen schlie\u00dfen die Ecke zum Abstellraum, einer davon als T\u00fcr.');

    /* Loading-Zustand */
    var gen = this.q('[data-lk-generate]');
    if (gen) { gen.disabled = s.loading; gen.textContent = s.loading ? 'Erzeuge \u2026' : 'Design erzeugen'; }
    var urlInput = this.q('[data-lk-url]');
    if (urlInput) urlInput.disabled = s.loading;

    /* Lightbox */
    var lb = this.q('[data-lk-lightbox]');
    if (lb) {
      lb.hidden = s.lb === null;
      if (s.lb !== null) {
        var g = this.cfg.gallery || [];
        var img = lb.querySelector('img');
        if (img) img.src = g[s.lb];
        set('[data-lk-lbcount]', (s.lb + 1) + ' / ' + g.length);
      }
    }

    /* Termin */
    show('[data-lk-termin-body]', s.termin);
    this.qa('[data-lk-tage] .lk-chip').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.id === s.tag ? 'true' : 'false');
    });
    this.qa('[data-lk-slots] .lk-chip').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.id === s.slot ? 'true' : 'false');
    });
    set('[data-lk-terminnote]', s.tag && s.slot
      ? 'Wir best\u00e4tigen den Termin per Mail mit Videocall-Link.'
      : 'Tag und Uhrzeit w\u00e4hlen \u2014 oder offen lassen, wir schlagen Zeiten vor.');
    var submit = this.q('[data-lk-submit]');
    if (submit) {
      submit.disabled = s.sending;
      submit.textContent = s.sending ? 'Wird gesendet \u2026'
        : s.termin ? 'Angebot & Termin anfordern' : 'Angebot erhalten';
    }
  };

  /* ---------- Absenden ---------- */
  Konfigurator.prototype.submit = function (e) {
    var api = this.cfg.leadApi;
    // Ohne Node-Endpoint: normales Shopify-Contact-Form (POST /contact) durchlassen.
    if (!api) return;

    e.preventDefault();
    var self = this, s = this.state, d = this.derive();
    var form = e.currentTarget;
    var t = (this.tage || []).find(function (x) { return x.id === s.tag; });
    var fd = new FormData(form);
    var payload = {
      firma: fd.get('contact[company]') || '',
      name: fd.get('contact[name]') || '',
      email: fd.get('contact[email]') || '',
      telefon: fd.get('contact[phone]') || '',
      website: fd.get('contact[website]') || '',
      konfiguration: {
        typ: s.typ, typLabel: d.typName, breite: s.breite,
        quadratmeter: d.qm, richtpreis: d.price,
        zubehoer: d.extras, beschreibung: d.masz,
        designBild: s.img && s.img.slice(0, 5) === 'data:' ? s.img : (s.img || null)
      },
      termin: s.termin ? { tag: s.tag, uhrzeit: s.slot, label: t && s.slot ? t.label + ' um ' + s.slot + ' Uhr' : null } : null,
      shop: this.cfg.shop,
      seite: window.location.href
    };

    this.set({ sending: true });
    var err = this.q('[data-lk-error]');
    if (err) err.hidden = true;

    fetch(api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json().catch(function () { return {}; }); })
      .then(function () {
        self.set({ sending: false });
        self.q('[data-lk-form-wrap]').hidden = true;
        var done = self.q('[data-lk-sent]');
        done.hidden = false;
        var tl = self.q('[data-lk-sent-termin]');
        if (tl) {
          var label = s.termin ? (t && s.slot ? t.label + ' um ' + s.slot + ' Uhr' : 'Wir schlagen Ihnen Zeiten vor') : '';
          tl.hidden = !label;
          var strong = tl.querySelector('strong');
          if (strong) strong.textContent = label;
        }
        var kl = self.q('[data-lk-sent-konfig]');
        if (kl) kl.textContent = d.masz;
        done.scrollTop = 0;
      })
      .catch(function () {
        self.set({ sending: false });
        if (err) {
          err.hidden = false;
          err.textContent = 'Senden fehlgeschlagen. Bitte rufen Sie uns an oder versuchen Sie es erneut.';
        }
      });
  };

  function init() {
    document.querySelectorAll('[data-lk-root]').forEach(function (el) {
      if (el.__lk) return;
      el.__lk = new Konfigurator(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', init);
})();
